package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_08_29_Day_4() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes see the flying creature again and identify it as a giant Roc. The Roc seems agitated by ominous, localized storm clouds. Goram and Caper suspect that the clouds are unnatural (perhaps summoned) and want a closer look.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A Storm Giant knelt at an altar in the middle of a ring of standing stones performing some kind of ritual. The Roc circled 60 feet in the air. The Giant proclaimed that he was summoning “Ultimate Power!” Caper attempted to charm the Giant but a massive battle broke out instead.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth carelessly rushed toward the Giant, but a veteran human soldier who was hiding behind one of the standing stones ambushed the brave Tabaxi. Several other soldiers were lying in wait, and a pair of air elementals joined the fray. The heroes unleashed a torrent of magical fire upon the Storm Giant, and Bigglesworth finished him off just in time for Caper to dispel the altar, ending the ritual. The heroes battled the remaining soldiers and air elementals, killing all but one soldier who fled to the south.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Meanwhile, the Roc didn’t appreciate that the heroes were trying to help it. The creature took particular interest in Bigglesworth, attacking him several times. In the second wave of attacks, the Roc was able to grab Bigglesworth, fly him 70 feet in the air, and drop him, but the Tabaxi landed on his feet.")
    }
}
